var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.501,
    height: 24.5,
    viewBox: "0 0 20.501 24.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "user_kujtesa",
    transform: "translate(0.251 0.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_174",
    "data-name": "Path 174",
    d: "M372.889,545.8c-.28-.074-.565-.133-.839-.225a3.613,3.613,0,0,1-2.664-3.269,12.183,12.183,0,0,1,.81-5.738,4.912,4.912,0,0,1,2.181-2.628,4.405,4.405,0,0,1,2.2-.537,1.659,1.659,0,0,1,.716.244c.361.2.7.443,1.048.659a5.331,5.331,0,0,0,5.993,0c.279-.172.562-.339.823-.535a2,2,0,0,1,1.574-.333,4.446,4.446,0,0,1,3.4,2.425,10.032,10.032,0,0,1,1.1,3.908,18.522,18.522,0,0,1,.092,2.057,3.827,3.827,0,0,1-3.58,3.932c-.024,0-.046.029-.068.044Zm6.44-1.407v0c1.99,0,3.98.018,5.97-.006a2.481,2.481,0,0,0,2.624-2.682,20.294,20.294,0,0,0-.147-2.264,7.867,7.867,0,0,0-.847-2.85,3.022,3.022,0,0,0-2.59-1.77.57.57,0,0,0-.3.07c-.327.2-.642.412-.968.612a6.63,6.63,0,0,1-6.72.409c-.586-.282-1.121-.67-1.682-1.007a.477.477,0,0,0-.231-.1,2.875,2.875,0,0,0-1.984.813,4.566,4.566,0,0,0-1.01,1.613,12.093,12.093,0,0,0-.69,4.714,2.331,2.331,0,0,0,1.1,2.007,3.172,3.172,0,0,0,1.766.439Z",
    transform: "translate(-369.328 -521.797)",
    stroke: "#fff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_175",
    "data-name": "Path 175",
    d: "M450.367,341.571a5.778,5.778,0,1,1-5.8-5.773A5.778,5.778,0,0,1,450.367,341.571Zm-1.406.039a4.373,4.373,0,1,0-4.4,4.351A4.391,4.391,0,0,0,448.96,341.61Z",
    transform: "translate(-434.733 -335.799)",
    stroke: "#fff",
    strokeWidth: 0.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.ecad6a26414ee365e717e1c9948147ac.svg";
export { ForwardRef as ReactComponent };